import { render, staticRenderFns } from "./onLineVideo.vue?vue&type=template&id=392b8935&scoped=true&"
import script from "./onLineVideo.vue?vue&type=script&lang=js&"
export * from "./onLineVideo.vue?vue&type=script&lang=js&"
import style0 from "./onLineVideo.vue?vue&type=style&index=0&id=392b8935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392b8935",
  null
  
)

export default component.exports